import Vue from 'vue'
import DashHome from './App.vue'
import Buefy from 'buefy'

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

if(document.getElementById("staffDashHomeApp")){
    new Vue({
        render: h => h(DashHome, {
            props:{
                lastLogins: document.getElementById("staffDashHomeApp").getAttribute("last-logins"),
                anonCarts: document.getElementById("staffDashHomeApp").getAttribute("anon-carts"),
                userCarts: document.getElementById("staffDashHomeApp").getAttribute("user-carts"),
                ordersApproval: document.getElementById("staffDashHomeApp").getAttribute("orders-approval"),
                ordersPending: document.getElementById("staffDashHomeApp").getAttribute("orders-pending"),
            }
        })
    }).$mount("#staffDashHomeApp")
}